import { Component, inject, ViewContainerRef } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { VdsDrawerComponent, VdsDrawerConfig } from "@cce/design-system/drawer";
import { VdsIconButtonComponent } from "@cce/design-system/button";
import { VdsIconComponent } from "@cce/design-system/icon";
import { VdsNavItemComponent, VdsSubNavToolbarComponent } from "@cce/design-system/navigation";
import { Router, RouterLink } from "@angular/router";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { AnnouncementDetailsComponent, AnnouncementsListComponent } from "@dcc/vestas-online/notification-area/announcements/feat";
import { BetaFeaturesTabComponent } from "@dcc/vestas-online/notification-area/beta-access/feat";
import { VdsTextLinkComponent } from "@cce/design-system/link";

export type DrawerView = "announcements" | "announcement-details" | "early-access";

@Component({
    selector: "vo-notifications-sidebar",
    templateUrl: "./sidebar.component.html",
    host: {
        class: "contents"
    },
    imports: [
        VdsDrawerComponent,
        VdsIconButtonComponent,
        VdsIconComponent,
        VdsSubNavToolbarComponent,
        AnnouncementsListComponent,
        BetaFeaturesTabComponent,
        RouterLink,
        VdsNavItemComponent,
        TranslocoDirective,
        AnnouncementDetailsComponent,
        VdsTextLinkComponent
    ]
})
export class SidebarComponent {
    private vcr = inject(ViewContainerRef);
    private router = inject(Router);

    public readonly drawerConfig: VdsDrawerConfig = {
        viewContainerRef: this.vcr,
        position: "right",
        width: "445px",
        restoreFocus: false
    };

    public drawerView = injectQueryParams((params) => getCurrentView(params["sbView"]));

    public drawerOpen = injectQueryParams((params) => !!params["sb"]);

    public closeDrawer(): void {
        this.router.navigate([], { queryParams: { sb: null, sbView: null, sbViewId: null }, queryParamsHandling: "merge" });
    }
}

function getCurrentView(param: string): DrawerView {
    switch (param) {
        case "announcements":
            return "announcements";
        case "announcement-details":
            return "announcement-details";
        case "early-access":
            return "early-access";
        default:
            return "announcements";
    }
}
